// HACK: PrimeReact <Calendar> 只操作瀏覽器本地時區的 Date 物件，無法直接以 UTC 運作。
// 以下兩個函式透過重新解讀 Date 的各欄位來繞過此限制。

/**
 * 將 Calendar 回傳的本地 Date 重新解讀為 UTC Date。
 * 例如使用者在 UTC+8 選了 4/16 → Calendar 回傳 `2026-04-16T00:00:00+08:00`
 * → 此函式回傳 `2026-04-16T00:00:00.000Z`
 */
export function calendarValueToUTC(date: Date): Date {
  return new Date(Date.UTC(
    date.getFullYear(), date.getMonth(), date.getDate(),
    date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds(),
  ))
}

/**
 * 將 UTC Date 轉為本地表示，使 Calendar 顯示正確的日期。
 * 與 calendarValueToUTC 互為反函式。
 * 例如 UTC Date `2026-04-16T00:00:00.000Z`
 * → 在 UTC+8 環境下回傳 `2026-04-16T00:00:00+08:00`
 * → Calendar 顯示 4/16 而非因時區偏移顯示 4/15
 */
export function utcToCalendarValue(date: Date): Date {
  return new Date(
    date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate(),
    date.getUTCHours(), date.getUTCMinutes(), date.getUTCSeconds(), date.getUTCMilliseconds(),
  )
}

export function nowTruncatedToDay(): Date {
  const now = new Date()
  now.setUTCHours(0, 0, 0, 0)
  return now
}

export function nowTruncatedToMinute(): Date {
  const now = new Date()
  now.setUTCSeconds(0, 0)
  return now
}
